require('./_wks-define')('asyncIterator');



// WEBPACK FOOTER //
// ./node_modules/babel-polyfill/node_modules/core-js/modules/es7.symbol.async-iterator.js